/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserTournamentProfileStats } from './UserTournamentProfileStats';
import {
    UserTournamentProfileStatsFromJSON,
    UserTournamentProfileStatsFromJSONTyped,
    UserTournamentProfileStatsToJSON,
    UserTournamentProfileStatsToJSONTyped,
} from './UserTournamentProfileStats';

/**
 * 
 * @export
 * @interface UserTournamentProfile
 */
export interface UserTournamentProfile {
    /**
     * 
     * @type {string}
     * @memberof UserTournamentProfile
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentProfile
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentProfile
     */
    profilePhoto?: string;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentProfile
     */
    memberSince?: number;
    /**
     * 
     * @type {UserTournamentProfileStats}
     * @memberof UserTournamentProfile
     */
    stats: UserTournamentProfileStats;
}

/**
 * Check if a given object implements the UserTournamentProfile interface.
 */
export function instanceOfUserTournamentProfile(value: object): value is UserTournamentProfile {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('stats' in value) || value['stats'] === undefined) return false;
    return true;
}

export function UserTournamentProfileFromJSON(json: any): UserTournamentProfile {
    return UserTournamentProfileFromJSONTyped(json, false);
}

export function UserTournamentProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTournamentProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'displayName': json['displayName'],
        'profilePhoto': json['profilePhoto'] == null ? undefined : json['profilePhoto'],
        'memberSince': json['memberSince'] == null ? undefined : json['memberSince'],
        'stats': UserTournamentProfileStatsFromJSON(json['stats']),
    };
}

export function UserTournamentProfileToJSON(json: any): UserTournamentProfile {
    return UserTournamentProfileToJSONTyped(json, false);
}

export function UserTournamentProfileToJSONTyped(value?: UserTournamentProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
        'profilePhoto': value['profilePhoto'],
        'memberSince': value['memberSince'],
        'stats': UserTournamentProfileStatsToJSON(value['stats']),
    };
}

